module.exports = __webpack_public_path__ + "img/arrow-right-white-white.514bed91.svg";